import React, { useState, Fragment }from 'react'
import { Link } from 'react-router-dom';
import Image from '../Image'
import { animalPercent } from '../../../utils/functions';
import W from '../Word';
import {isNil, upperFirst} from 'lodash';
import { useTranslation } from 'react-i18next';

const ProfileBuyer = ( {totalBuyers, totalPackages, soldPercentage } ) => {
  const [toggled, setToggled] = useState(false)
  const { t } = useTranslation();
  if(totalBuyers < 1){
    totalBuyers = 1;
  }
  function HandleTooltipPopup(event) {
    event.preventDefault()
    setToggled(!toggled)
  }

  let toggledClass = (toggled) ? "" : "";
  
  var totalBuyers2 = (totalPackages > 45) ? Math.ceil(parseInt(totalBuyers)/2) : totalBuyers;
  var totalPackages2 = (totalPackages > 45) ? Math.ceil(parseInt(totalPackages)/2) : totalPackages;

    return (
      <Fragment>
      <div className={`buyer tooltip  tooltip--center`}>
        <div className="profile tooltip__info">
          <a className="tooltip__info--link" onClick={HandleTooltipPopup}></a>
          <div className="avatar">
            <i className="icon-user"></i>
          </div>
          <div className="info buyerpopup2">
            <span className="title">
              <span className="icon-info"></span> <span className="packages-sold text--red">{totalBuyers2}</span>/{totalPackages2} 
              <br /> <W>product.buyers</W> 
            </span>
          </div>
        </div>
        <div className={`tooltip__content tooltip__buyers ${toggledClass}`}>
          <a className="icon-close align__right" onClick={HandleTooltipPopup}></a>
          <div className="tooltip__content--info buyers__info">
            <div className="row">
              <div className="col-4 tooltip__content--icon buyers__info">
                <span className="icon-users"></span>
              </div>
              <div className="col-8 tooltip__content--list buyers__info">
                <ul className="list list--no-list">
                  <li className="buyers--sold">{upperFirst(t('product.sold'))}: <strong>{animalPercent(soldPercentage)}</strong>% </li>
                  <li className="buyers--buyers"><W>product.numberofbuyers</W>: <strong>{totalBuyers2}</strong> </li>
                  <li className="buyers--packages"><W>product.meatboxavailable</W>:
                    <strong>
                      {parseInt(totalPackages2)-parseInt(totalBuyers2)}
                    </strong> 
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/*<p>{props.excerpt} ...</p>*/}
        </div>
      </div>
    </Fragment>
    )
}

export default ProfileBuyer
